import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { stopImpersonating } from '../auth/slices/authSlice';
import type { RootState } from '../store/store';
import { Button, Space, Typography } from 'antd';
import { SafetyOutlined, ArrowLeftOutlined } from '@ant-design/icons';

const { Text } = Typography;

export const ImpersonationBanner: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const adminSession = useSelector((state: RootState) => state.auth.adminSession);
  const partner = useSelector((state: RootState) => state.auth.partner);

  if (!adminSession) {
    return null;
  }

  const handleStopImpersonation = () => {
    dispatch(stopImpersonating());
    navigate('/admin');
  };

  return (
    <div
      style={{
        width: '100%',
        backgroundColor: '#d97706',
        color: '#ffffff',
        padding: '8px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
        position: 'relative',
      }}
    >
      <Space size="middle">
        <SafetyOutlined style={{ fontSize: 18, color: '#fef3c7' }} />
        <Text style={{ color: '#ffffff', fontWeight: 600 }}>
          Modo Auditoría Activo: Estás visualizando la consola como{' '}
          <span style={{ textDecoration: 'underline' }}>{partner?.name || 'Aliado'}</span>
        </Text>
      </Space>

      <Button
        type="default"
        size="small"
        icon={<ArrowLeftOutlined />}
        onClick={handleStopImpersonation}
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.15)',
          color: '#ffffff',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          borderRadius: 6,
          fontWeight: 600,
        }}
      >
        Regresar a SAMA Admin
      </Button>
    </div>
  );
};

export default ImpersonationBanner;
